import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip } from '@lichtblick/photon/atoms/chip/chip';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { Text } from '@lichtblick/photon/atoms/text/text';
import classNames from 'classnames';
import { useMemo } from 'react';
import { RichText } from '../../helpers/RichText';
import { AButton } from '../AButton';
import styles from './m-text-intro.module.scss';
const themeMapping = {
    black: 'dark',
    white: 'standard'
};
export const MTextIntro = ({ accentColor = 'black', button, buttonVariant = 'link', centeredDesktop, centeredMobile, chip, className, headline, headlineProps, richText, textProps })=>{
    const elementMappers = useMemo(()=>({
            h1: ({ children })=>/*#__PURE__*/ _jsx(Headline, {
                    className: styles['rich-text-headline'],
                    renderAs: "h1",
                    size: headline ? 's' : 'l',
                    children: children
                }),
            h3: ({ children })=>/*#__PURE__*/ _jsx(Headline, {
                    className: styles['rich-text-headline'],
                    renderAs: "h3",
                    size: "s",
                    children: children
                }),
            p: ({ children })=>/*#__PURE__*/ _jsx(Text, {
                    renderAs: "p",
                    size: "l",
                    children: children
                })
        }), [
        headline
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(centeredMobile && styles['text-intro-centered-mobile'], centeredDesktop && styles['text-intro-centered-desktop'], className),
        "data-testid": "text-intro",
        children: [
            chip && /*#__PURE__*/ _jsx(Chip, {
                theme: themeMapping[accentColor],
                className: styles.chip,
                children: chip
            }),
            Boolean(headline) && /*#__PURE__*/ _jsx(Headline, {
                renderAs: "h2",
                ...headlineProps,
                className: styles.headline,
                children: headline
            }),
            richText && /*#__PURE__*/ _jsx(Text, {
                ...textProps,
                children: /*#__PURE__*/ _jsx(RichText, {
                    elementMappers: elementMappers,
                    richText: richText
                })
            }),
            button?.[0] && /*#__PURE__*/ _jsx(AButton, {
                ...button[0],
                className: styles.button,
                variant: buttonVariant
            })
        ]
    });
};

//# sourceMappingURL=MTextIntro.js.map